import { getBaseUrl, getPageUrl } from 'utils/getBaseUrl';

const supplementsDefaults = {
  title: 'Mitopure® | #1 Doctor Recommended Urolithin A',
  description:
    'Optimize your cellular health with Mitopure® by Timeline, the first and only Urolithin A supplement clinically-proven to target the root causes of aging.',
};

const skincareDefaults = {
  title: 'Skin Longevity Powered by Mitopure® (Urolithin A)',
  description:
    'Transform your skin health with the power of patented Swiss science. Research-backed formulas for results in as little as 15 days.',
};

export default (pagePath) => {
  const isSkincare = pagePath.includes('/skincare');

  const defaults = isSkincare ? skincareDefaults : supplementsDefaults;
  const imageFileName = isSkincare
    ? 'open-graph-skincare.jpg'
    : 'open-graph.jpg';

  return {
    titleTemplate: '%s - Timeline',
    title: defaults.title,
    description: defaults.description,
    openGraph: {
      type: 'website',
      locale: 'en_US',
      url: getPageUrl(pagePath),
      siteName: 'Timeline',
      title: defaults.title,
      description: defaults.description,
      images: [
        {
          url: `${getBaseUrl()}/${imageFileName}`,
          width: 1200,
          height: 630,
          alt: 'Open Graph Image',
        },
      ],
    },
  };
};
